import { Dispatch } from "react"
import ReactModal from "react-modal"
import { supabase } from "../database/SupabaseConnector"
import { useNavigate } from "react-router-dom"

type UserModalProps = {
  appContainer: HTMLDivElement | null | undefined
  isOpen: boolean
  setOpen: Dispatch<boolean>
  setManageSubscriptionModalOpen: Dispatch<boolean>
  setProfileModalOpen: Dispatch<boolean>
}

export const UserModal = (props: UserModalProps) => {
  const {
    appContainer,
    isOpen,
    setOpen,
    setManageSubscriptionModalOpen,
    setProfileModalOpen,
  } = props

  const navigate = useNavigate()

  const handleSignOut = async () => {
    await supabase.auth.signOut()
    navigate("/login")
  }

  return (
    <ReactModal
      appElement={appContainer || undefined}
      isOpen={isOpen}
      onRequestClose={() => setOpen(false)}
      style={{
        content: {
          top: 45,
          left: 20,
          width: 200,
          height: 150,
          padding: 20,
          paddingBottom: 10,
          zIndex: 10,
          border: "border: 1px solid #B7C4D4",
          borderRadius: 12,
        },
        overlay: {
          zIndex: 10,
          background: "rgba(0,0,0,0.1)",
        },
      }}
    >
      <div className="app-menu-item">
        <button
          onClick={() => {
            setManageSubscriptionModalOpen(true)
            setOpen(false)
          }}
          className="app-menu-button"
        >
          Subscription
        </button>
      </div>

      <div className="app-menu-item">
        <button
          onClick={() => {
            setProfileModalOpen(true)
            setOpen(false)
          }}
          className="app-menu-button"
        >
          Profile
        </button>
      </div>

      <div className="app-menu-item">
        <button
          onClick={() => {
            navigate("/invite")
            setOpen(false)
          }}
          className="app-menu-button"
        >
          Invite Team Member
        </button>
      </div>

      <div className="app-menu-item">
        <button onClick={handleSignOut} className="app-menu-button">
          Sign Out
        </button>
      </div>
    </ReactModal>
  )
}
